import { Button, Classes, Dialog, Icon, DialogProps, Intent } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import * as React from 'react'
import { UprightStyle } from '../../../../../../types'

interface Props extends DialogProps {
  onCancel: () => void
}

const styles: UprightStyle = {
  container: { maxWidth: 360, paddingBottom: 0 },
  flex: { display: 'flex' },
  cancel: { marginRight: 12, maxWidth: 82, width: '100%' },
  warningContainer: { marginLeft: 18 },
  confirmation: { margin: `20px 0 36px 0` }
}

const ICON_SIZE = 30
const ICON_COLOR = '#5C7080'

const OptionModalDeleteDialog = (props: Props) => (
  <Dialog
    {...props}
    title={undefined}
    isCloseButtonShown={false}
    canOutsideClickClose={false}
    canEscapeKeyClose={false}
    style={styles.container}
  >
    <div className={Classes.DIALOG_BODY} style={styles.flex}>
      <Icon size={ICON_SIZE} icon={IconNames.WARNING_SIGN} color={ICON_COLOR} />
      <div style={styles.warningContainer}>
        <p>Deleting the option will also permanently delete related product variants.</p>

        <p style={styles.confirmation}>Are you sure you want to delete?</p>
        <div style={styles.flex}>
          <Button style={styles.cancel} onClick={props.onCancel}>
            Cancel
          </Button>
          <Button onClick={props.onClose} fill intent={Intent.DANGER}>
            Yes, delete option
          </Button>
        </div>
      </div>
    </div>
  </Dialog>
)

export default OptionModalDeleteDialog
